<!--投产比（曲线+柱状图）-->
<template>
<div class="pr commonborder flex_row">
  <div id="pr_line1" class="echarts"></div>
</div>

</template>

<script>
import api from '@/apis/power/power';
let echarts = require("echarts/lib/echarts");
export default {
  data() {
    return {
    };
  },
  computed:{
    //轴线颜色
    axisLineColor(){
      return this.$store.state.axisLineColor
    },
    //轴文字颜色
    axisLabelColor(){
      return this.$store.state.axisLabelColor
    },
    //网格线属性
    splitLineStyle(){
      return this.$store.state.splitLineStyle
    },
    //图例文字颜色
    legendTextColor(){
      return this.$store.state.legendTextColor
    }
  },
  methods: {
    //获取数据
    getList(){
      api.getProratio().then(res=>{
        if(res.code==10000){
          let _data = res.data.list[0]
          console.log(_data);
          let _income = [
            _data.oneIncome?_data.oneIncome:0,
            _data.twoIncome?_data.twoIncome:0,
            _data.threeIncome?_data.threeIncome:0,
            _data.fourIncome?_data.fourIncome:0,
            _data.fiveIncome?_data.fiveIncome:0,
            _data.sixIncome?_data.sixIncome:0,
            _data.sevenIncome?_data.sevenIncome:0,
            _data.eightIncome?_data.eightIncome:0,
            _data.nineIncome?_data.nineIncome:0,
            _data.tenIncome?_data.tenIncome:0,
            _data.elevenIncome?_data.elevenIncome:0,
            _data.twelveIncome?_data.twelveIncome:0,
          ]
          let _input = [
            _data.oneInput?_data.oneInput:0,
            _data.twoInput?_data.twoInput:0,
            _data.threeInput?_data.threeInput:0,
            _data.fourInput?_data.fourInput:0,
            _data.fiveInput?_data.fiveInput:0,
            _data.sixInput?_data.sixInput:0,
            _data.sevenInput?_data.sevenInput:0,
            _data.eightInput?_data.eightInput:0,
            _data.nineInput?_data.nineInput:0,
            _data.tenInput?_data.tenInput:0,
            _data.elevenInput?_data.elevenInput:0,
            _data.twelveInput?_data.twelveInput:0,
          ]
          let _ratio = [
            ((_data.oneIncome-_data.oneInput)/_data.oneInput*100).toFixed(2)==Infinity?0:((_data.oneIncome-_data.oneInput)/_data.oneInput*100).toFixed(2),
            ((_data.twoIncome-_data.twoInput)/_data.twoInput*100).toFixed(2)==Infinity?0:((_data.twoIncome-_data.twoInput)/_data.twoInput*100).toFixed(2),
            ((_data.threeIncome-_data.threeInput)/_data.threeInput*100).toFixed(2)==Infinity?0:((_data.threeIncome-_data.threeInput)/_data.threeInput*100).toFixed(2),
            ((_data.fourIncome-_data.fourInput)/_data.fourInput*100).toFixed(2)==Infinity?0:((_data.fourIncome-_data.fourInput)/_data.fourInput*100).toFixed(2),
            ((_data.fiveIncome-_data.fiveInput)/_data.fiveInput*100).toFixed(2)==Infinity?0:((_data.fiveIncome-_data.fiveInput)/_data.fiveInput*100).toFixed(2),
            ((_data.sixIncome-_data.sixInput)/_data.sixInput*100).toFixed(2)==Infinity?0:((_data.sixIncome-_data.sixInput)/_data.sixInput*100).toFixed(2),
            ((_data.sevenIncome-_data.sevenInput)/_data.sevenInput*100).toFixed(2)==Infinity?0:((_data.sevenIncome-_data.sevenInput)/_data.sevenInput*100).toFixed(2),
            ((_data.eightIncome-_data.eightInput)/_data.eightInput*100).toFixed(2)==Infinity?0:((_data.eightIncome-_data.eightInput)/_data.eightInput*100).toFixed(2),
            ((_data.nineIncome-_data.nineInput)/_data.nineInput*100).toFixed(2)==Infinity?0:((_data.nineIncome-_data.nineInput)/_data.nineInput*100).toFixed(2),
            ((_data.tenIncome-_data.tenInput)/_data.tenInput*100).toFixed(2)==Infinity?0:((_data.tenIncome-_data.tenInput)/_data.tenInput*100).toFixed(2),
            ((_data.elevenIncome-_data.elevenInput)/_data.elevenInput*100).toFixed(2)==Infinity?0:((_data.elevenIncome-_data.elevenInput)/_data.elevenInput*100).toFixed(2),
            ((_data.twelveIncome-_data.twelveInput)/_data.twelveInput*100).toFixed(2)==Infinity?0:((_data.twelveIncome-_data.twelveInput)/_data.twelveInput*100).toFixed(2),
          ]
          this.pr_line1(_income,_input,_ratio)
        }
      })
    },
    pr_line1(a,b,c){
      let pr_line1 = echarts.init( document.getElementById('pr_line1') );
      pr_line1.setOption({
          color:['#24ffb1','#00ccff','#ffea04'],
          tooltip: { trigger: 'axis',textStyle:{fontSize: this.$echartsFontSize},
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
              data: ['产出', '投入','投产比'],
              left: 'center', top:8,
              textStyle: {
                color: this.legendTextColor,fontSize:this.$echartsFontSize
              },
              itemWidth: 14,
              itemHeight: 14,
          },
          xAxis: {
              type: 'category',
              axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize,interval: 0},
              axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
              axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true},
              data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          },
          yAxis: [
            { 
              name:'万元 ',
              nameTextStyle:{color:this.axisLabelColor,align:'right',fontSize:this.$echartsFontSize-2},
              axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
              axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
              // splitNumber:5, 
              nameGap:this.$echartsFontSize,
              splitLine:{show:true,lineStyle:this.splitLineStyle},
              axisTick: { show: true ,lineStyle:{color:this.axisLineColor}},
            },
            { 
              name:'  %',
              nameTextStyle:{color:this.axisLabelColor,align:'left',fontSize:this.$echartsFontSize-2},
              axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
              axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
              // splitNumber:3, 
              nameGap:this.$echartsFontSize,
              splitLine:{show:false},
              axisTick: { show: true ,lineStyle:{color:this.axisLineColor}},
            }
          ],
          grid: { left: '4%',right:'4%',top:'22%',bottom:'4%',containLabel: true},
          series: [
            {
              name: '产出',
              type: 'bar',
              stack: '总量',
              barWidth:'40%',
              data: a,
            },
            {
              name: '投入',
              type: 'bar',
              stack: '总量',
              barWidth:'40%',
              data: b,
            },
            {
              name: '投产比',
              yAxisIndex: 1,
              type: 'line',
              data: c,
            }
          ] 
      })
      this.$common.moveEcharts(12,pr_line1)
   },
    
  },
  mounted() {
    this.getList()
  },
};
</script>

<style lang="less" scoped>
.pr{
  #pr_line1{ height: 100%; width: 100%;}
}
</style>